export function capitalizeFirstLetter(value) {
    if (value.length === 0)
        return "";
    return value.charAt(0).toUpperCase() + value.slice(1);
}
